import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import { Typography } from '@navi/web-ui/lib/primitives';
import { IDrawerHeader } from '../../types';

const DrawerHeader = (props: IDrawerHeader) => {
  const { icon, title, subTitle, loading = false } = props;

  return (
    <div className="flex flex-1 gap-2 ">
      <SuspenseLoader
        loading={loading}
        fallBack={
          <LineLoader
            numberOfLines={1}
            childrenType="H3"
            dimenshionUnit="px"
            lineStyle="rounded-sm w-6 h-6"
          />
        }
      >
        {icon}
      </SuspenseLoader>
      <div>
        <SuspenseLoader
          loading={loading}
          fallBack={
            <LineLoader numberOfLines={1} childrenType="H3" dimenshionUnit="px" lineWidth={160} />
          }
        >
          <Typography
            variant="h3"
            color="var(--navi-color-gray-c1)"
            className="truncate max-w-[400px]"
          >
            {title ?? '--'}
          </Typography>
        </SuspenseLoader>
        <SuspenseLoader
          loading={loading}
          fallBack={
            <LineLoader
              containerStyle="mt-[2px]"
              numberOfLines={1}
              childrenType="H5"
              dimenshionUnit="px"
              lineWidth={100}
            />
          }
        >
          <Typography
            variant="h5"
            color="var(--navi-color-gray-c3)"
            className="mt-[2px] truncate max-w-[400px]"
          >
            {subTitle}
          </Typography>
        </SuspenseLoader>
      </div>
    </div>
  );
};

export default DrawerHeader;
